<template>
  <div
    class="pull-right"
    style="margin-top: 15px"
  >
    <button
      v-for="item in activeLanguages"
      :id="item.iso"
      :key="item.iso"
      :slot="item.iso"
      :lang="item.iso"
      class="available-language btn"
      :aria-label="getChangeLanguageDescription(item.isoUnderscored)"
      :class="{
        'btn-primary disabled-pointer' : item.iso === computedLanguage.iso,
        'btn-info' : item.iso !== computedLanguage.iso
      }"
      type="button"
      @click="changeLanguage(item)"
    >
      {{ item.code.toUpperCase() }}
    </button>
  </div>
</template>

<script>
import {changeLanguage, activeLanguages, selectedLanguage, i18n} from '@/locales'

export default {
  data() {
    return {
      activeLanguages,
      selectedLanguage,
      customLanguage: undefined,
    }
  },
  computed: {
    computedLanguage() {
      return this.customLanguage ? this.customLanguage : selectedLanguage
    },
  },
  watch: {
    // this watch look for language changes, and change all LanguageSelector component instances
    '$i18n.locale'(){
      Object.values(this.activeLanguages).forEach(val => val.isoUnderscored === i18n.locale ? this.customLanguage = val : '')
    }
  },
  methods: {
    changeLanguage(item) {
      this.customLanguage = item
      changeLanguage(item.isoUnderscored)
    },
    getChangeLanguageDescription(languageVariant) {
      return i18n.getLocaleMessage(languageVariant)['navbar']['language_selection_label']
    }
  }
}
</script>

<style lang="less" scoped>
</style>
